import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef, TextOnlySnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class VersionUpdateService {
  private readonly fiveMinutesInMs = 300000;

  constructor(
    private translate: TranslateService,
    private snackBar: MatSnackBar,
  ) {}

  public handleVersionMismatch(): void {
    setTimeout(() => {
      window.location.reload();
    }, this.fiveMinutesInMs);

    const message: string = this.translate.instant('apiError.versionUpdate');
    const refresh: string = this.translate.instant('button.refresh');

    const snackBarRef: MatSnackBarRef<TextOnlySnackBar> = this.snackBar.open(message, refresh);

    snackBarRef.onAction().subscribe(() => {
      window.location.reload();
    });
  }
}
